import { useEffect } from 'react';
import HomePageContainer from '~/componentsPage/HomePage/HomePageContainer';
import PwaInstallPrompt from '~/components/PwaInstall/PwaInstallPrompt';

function HomePage() {
  return (
    <div data-page="HomePage" className="homePage">
      <HomePageContainer />
      <PwaInstallPrompt />
    </div>
  )
};

export default HomePage;
